import React, { useState, useEffect, useCallback } from "react";
import { Select, Row, Col, Form, Icon, Spin, DatePicker, Input, InputNumber, Button, Radio, message, Modal } from "antd";
import { BoldOutlined, PlusOutlined, ExclamationCircleOutlined, QuestionCircleOutlined, QuestionCircleFilled } from '@ant-design/icons';
import Mensajes from "../Mensajes/Mensajes";
import useAuth from "../../hooks/useAuth";
import moment from 'moment';
import axios from "axios";
import "./FormRegistroFormato.scss";
import { Redirect } from 'react-router';
import { Tooltip } from "@material-ui/core";

export default function FormRegistroFormato(props) {

    const urlConsultaDatos = `${localStorage.getItem('SERVERCENTRAL')}/obtenDatoGeneral`;

    const [redirect, setRedirect] = useState({
        redirecting: false,
        url: "/formatoDiscapacidad/formatoDiscapacidad",
        state: {},
    });
    //console.log("PROPS REGISTRO", props);
    const { getFieldDecorator } = props.form;
    //const [otroS, setOtroS] = useState(-1);
    //const [otroE, setOtroE] = useState(-1);
    const [otroS, setOtroS] = useState(
      props.general.secretario && props.general.secretario > 0
        ? -1
        : !props.general.secretario
        ? -1
        : 1
    );
    const [otroE, setOtroE] = useState(
      props.general.escrutador && props.general.escrutador > 0
        ? -1
        : !props.general.escrutador
        ? -1
        : 1
    );

    const [options, setOptions] = useState({
        data: props.distritos != [] ? props.distritos : [],
        loadingData: false
    });


    const [seccion, setSeccion] = useState({
        data: props.secciones != [] ? props.secciones : [],
        loadingData: false
    });
    const [secretario, setSecretario] = useState({
        data: props.secretarios != [] ? props.secretarios : [],
        loadingData: false
    });
    const [escrutador, setEscrutador] = useState({
        data: props.escrutadores != [] ? props.escrutadores : [],
        loadingData: false
    });

    const [nombreCS, setNombreCS] = useState({
        nombre: "",
        pApellido: "",
        sApellido: "",
    });
    const [nombreCE, setNombreCE] = useState({
        nombre: "",
        pApellido: "",
        sApellido: "",
    });

    console.log("props.general.secretario:=>", props.general.secretario);

    const [general, setGeneral] = useState(props.general)
    console.log("Props general", props.general)

    const [deshabilitar, setDeshabilitar] = useState(true);
    const [requeridoC, setRequeridoC] = useState(props.accion == 1 ? false : true);
    const [deshabilitarC, setdeshabilitarC] = useState(props.accion === 1 ? true : false);
    const [requerido, setRequerido] = useState(false);
    const [requeridoGeneral, setRequeridoGeneral] = useState(false);
    const [visibleG, setVisibleG] = useState(props.general.seccion === "" ? 0 : 1);
    const [visible, setVisible] = useState(props.general.participacion == 2 && props.accion !== 1 ? 1 : null);


    //console.log("response options:=>", options, seccion, secretario, escrutador, cSexo, cApoyo, cDiscapacidad);

    const obtenerSecciones = (d) => {
        //console.log('Received values of form datos: ', d);
        //  props.general.distrito=d;

        props.handleSecciones(d)
        // props.handleSelect(e);

    };

    const obtenerFuncionarios = (s) => {
        //console.log('Received values of forme+++s: ', s);
        props.general.idGeografico = seccion.data[s];
        props.handleFuncionarios(s);


        /* Object.entries(seccion.data).map((value, index) => {
             console.log("seccionesd1", props.general.seccion, "val ", value[1])
             if (props.general.seccion == value[1]) {
                 props.general.geografico = value[0]
                 console.log("seccionesd", props.general.geografico)
                 return props.general.geografico
             }
         })*/
        // props.handleSelect(e);
        //console.log('Received values of form datos: ', props.handleSelect(e));
    };

    const handleChangeDiscapcidad = (e) => {
        //console.log('Value changes5****, accion');

        //console.log(e.target.value);
      
        if (e.target.value === 2 && props.accion !== 1) {
            setVisible(1)
            setRequeridoGeneral(true)
           

        }

        else {
            setVisible(0)
            setRequerido(false)   
        }

            general.participacion = e.target.value
      

        if (e.target.value === 2 && props.accion !== 1) {
            setVisible(1)
            setRequeridoGeneral(true)
        }
        else {
            setVisible(0)
            setRequerido(false)
        }
        props.general.participacion = e.target.value

        props.handleCambio(e.target.value)
    }

    const renderRedirectRegresar = () => {
        //console.log("REDIRECT1", redirect)
        if (redirect.redirecting) {
            return <Redirect
                to={{
                    pathname: redirect.url,
                    state: redirect.state
                }}
            />
        }
    }

    return (
        <div>
            {renderRedirectRegresar()}
            <h1 className="titulo-adjudicacion">Registro de personas con discapacidad que acudan a votar</h1>
            <label className="texto-14-adjudicacion">Los datos con ( <label className="rojo-adjudicacion">*</label> ) son requeridos.</label>
            <br />
            <br />
            <div>
                {//console.log("Requeridos", requeridoC)
                }
                <Form id="registro" layout="vertical">
                    <Row>
                        <Col span={23} >
                            <label className="texto-18-adjudicacion-b">Datos generales</label>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col span={10}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Distrito</label>
                            </Col>
                        </Col>
                        <Col span={8}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Sección</label>
                            </Col>
                        </Col>
                        {visibleG === 1 ?
                            <Col span={4}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Casilla Especial</label>
                            </Col> : ""}
                    </Row>
                    <Row>
                        <Col span={10}>
                            <Col span={23}>
                                <Form.Item name="distrito" hasFeedback>
                                    {getFieldDecorator('distrito', {
                                        initialValue: general.distrito !== "" ? general.distrito : undefined,
                                        rules: [
                                            {
                                                required: requeridoC,
                                                message: 'Selecciona un Distrito.',
                                            }
                                        ],
                                    })(
                                        <Select
                                            placeholder="Selecciona"
                                            onChange={obtenerSecciones}
                                            disabled={props.accion == 2 ? true : deshabilitarC}
                                        >
                                            {Object.entries(options.data).map((value, index) => {
                                                return <Select.Option key={value[0]}>{value[1]}</Select.Option>;
                                            })}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={8}>
                            <Col span={23}>
                                <Form.Item name="seccion" hasFeedback>
                                    {getFieldDecorator('seccion', {
                                        initialValue: general.seccion !== "" ? general.seccion : undefined,
                                        rules: [
                                            {
                                                required: requeridoC,
                                                message: 'Selecciona una Sección.',
                                            }
                                        ],
                                    })(
                                        <Select
                                            placeholder="Selecciona"
                                            onChange={obtenerFuncionarios}
                                            disabled={props.accion == 2 ? true : deshabilitarC}
                                        >
                                            {Object.entries(seccion.data).map((value, index) => {
                                                return <Select.Option key={value[0]}>{value[0]}</Select.Option>;
                                            })}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        {visibleG === 1 ?
                            <Col span={4}>
                                <Col span={23}>
                                    <Form.Item name="casillaEspecial" hasFeedback>
                                        {getFieldDecorator('casillaEspecial', {
                                            initialValue: general.casillaEspecial !== -1 ? general.casillaEspecial : "",
                                            rules: [
                                                {
                                                    required: requeridoC,
                                                    message: 'Selecciona si el registro es de una casilla especial.',
                                                }
                                            ],
                                        })(
                                            <Radio.Group
                                                disabled={deshabilitarC}
                                                onChange={value => {
                                                    //console.log(value.target.value, "Casilla espe1")
                                                    props.general.casillaEspecial = value.target.value
                                                }}>
                                                <Radio value={2}> Sí </Radio>
                                                <Radio value={1}> No </Radio>
                                                &nbsp;  &nbsp;
                                                <br /><span />
                                            </Radio.Group>

                                        )}
                                    </Form.Item>
                                </Col>
                            </Col>
                            : ""}
                    </Row>
                    {visibleG === 1 ?
                        <>

                            <Row>

                                <Col span={8}>
                                    <Col span={23}>
                                        <label className="rojo-sesion">* </label><label className="texto-16-sesion">Nombre de la o el secretario de casilla</label>
                                    </Col>
                                </Col>
                                {otroS !== 1 && otroE !== 1 ?
                                    <Col span={8}>
                                        <Col span={23}>
                                            <label className="rojo-sesion">* </label><label className="texto-16-sesion">Nombre de la o el segundo escrutador de casilla</label>
                                        </Col>
                                    </Col>
                                    : otroS == 1 ?
                                        <> <Col span={6}>
                                            <Col span={23}>
                                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Nombre(s)</label>
                                            </Col>
                                        </Col>
                                            <Col span={5}>
                                                <Col span={23}>
                                                    <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Primer Apellido</label>
                                                </Col>
                                            </Col>
                                            < Col span={5}>
                                                <Col span={23}>
                                                    <label className="rojo-adjudicacion"> </label><label className="texto-16-adjudicacion">Segundo Apellido</label>
                                                </Col>
                                            </Col></>
                                        : ""}
                            </Row>
                            <Row>
                                <Col span={8}>
                                    <Col span={23}>
                                        {//console.log("datos sec ", general.secretario)
                                        }
                                        <Form.Item name="secretario" hasFeedback>
                                            {getFieldDecorator('secretario', {
                                                initialValue: general.secretario !== "" ? general.secretario : undefined,
                                                rules: [
                                                    {
                                                        required: requeridoC,
                                                        message: 'Selecciona el nombre de la o el secretario de casilla.',
                                                    }
                                                ],
                                            })(
                                                <Select
                                                    placeholder="Selecciona"
                                                    disabled={deshabilitarC}
                                                    onSelect={value => {
                                                        //console.log("Valores select2", value, "t", tipoCaptura)
                                                        value === '0' ? setOtroS(1) :
                                                            setOtroS(-1)
                                                        //let splited = value.split("-")
                                                        //setTipo(splited[0])
                                                        props.general.secretario = value
                                                        props.general.nombreOtroSecretario = ""
                                                        props.general.primerApellidoOtroSecretario = ""
                                                        props.general.segundoApellidoOtroSecretario = ""
                                                    }}
                                                >
                                                    {Object.entries(secretario.data).map((value, index) => {
                                                        return <Select.Option key={value[1]}>{value[0]}</Select.Option>;
                                                    })}
                                                    {
                                                        // TODO RMA COMENTA 
                                                        /*props.secretarioN != "" ?
                                                    <Select.Option key={-1}>{props.secretarioN}</Select.Option> : "" */}
                                                    <Select.Option key={0}>OTRO</Select.Option>

                                                </Select>

                                            )}
                                        </Form.Item>
                                    </Col>
                                </Col>
                                {console.log("otroS:=>", otroS)}
                                {console.log("otroE:=>", otroE)}
                                {otroS !== 1 && otroE !== 1 ?
                                    <Col span={8}>
                                        <Col span={23}>
                                            <Form.Item name="escrutador" hasFeedback>
                                                {getFieldDecorator('escrutador', {
                                                    initialValue: general.escrutador !== "" ? general.escrutador : undefined,
                                                    rules: [
                                                        {
                                                            required: requeridoC,
                                                            message: 'Selecciona el nombre de la o el segundo escrutador de casilla.',
                                                        }
                                                    ],
                                                })(
                                                    <Select
                                                        placeholder="Selecciona"
                                                        disabled={deshabilitarC}
                                                        onSelect={value => {
                                                            value === '0' ?
                                                                setOtroE(1) :
                                                                setOtroE(-1)
                                                            props.general.escrutador = value
                                                            props.general.nombreOtroEscrutador = ""
                                                            props.general.primerApellidoOtroEscrutador = ""
                                                            props.general.segundoApellidoOtroEscrutador = ""
                                                        }}
                                                    >
                                                        {Object.entries(escrutador.data).map((value, index) => {
                                                            return <Select.Option key={value[1]}>{value[0]}</Select.Option>;
                                                        })}
                                                        {// TODO RMA COMENTA 
                                                            /*props.escrutadorN != "" ?
                                                            <Select.Option key={-1}>{props.escrutadorN}</Select.Option> : "" */}

                                                        <Select.Option key={0}>OTRO</Select.Option>

                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Col>
                                    : otroS === 1 ?
                                        <> <Col span={6}>
                                            <Col span={23}>
                                                <Form.Item name="otroSN" hasFeedback>
                                                    {getFieldDecorator('otroSN', {
                                                        initialValue: general.nombreOtroSecretario !== "" ? general.nombreOtroSecretario : undefined,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: 'Escribe el nombre(s) de la o el secretario de casilla.',
                                                                
                                                            }, 
                                                            {
                                                                pattern: /^[ A-ZÑa-zñáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ']+$/,
                                                                message: 'Solo acepta (a-z, A-Z, Á-Ú, á-ú) '
                                                            }
                                                        ],
                                                    })(
                                                        <Input
                                                            //className="texto"
                                                            placeholder="Escribe"
                                                            maxLength={50}
                                                            onChange={v => {
                                                                //console.log("valor de opcion", v.target.name,"hola" ,v.target.value.toUpperCase())
                                                                v.target.value = v.target.value.toUpperCase();
                                                                general.nombreOtroSecretario = v.target.value;
                                                                setNombreCS({
                                                                    nombre: v.target.value,
                                                                    pApellido: nombreCS.pApellido,
                                                                    sApellido: nombreCS.sApellido
                                                                })

                                                            }}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        </Col>
                                            <Col span={5}>
                                                <Col span={23}>
                                                    <Form.Item name="otroSPA" hasFeedback>
                                                        {getFieldDecorator('otroSPA', {
                                                            initialValue: general.primerApellidoOtroSecretario !== "" ? general.primerApellidoOtroSecretario : undefined,
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: 'Escribe el primer apellido de la o el secretario de casilla.',
                                                                },
                                                                {
                                                                    pattern: /^[ A-ZÑa-zñáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ']+$/, 
                                                                    message: 'Solo acepta (a-z, A-Z, Á-Ú, á-ú) '
                                                                }
                                                            ],
                                                        })(
                                                            <Input
                                                                //className="texto"
                                                                placeholder="Escribe"
                                                                maxLength={40}
                                                                onChange={v => {
                                                                    //console.log("valor de opcion", v.target.name,"hola" ,v.target.value.toUpperCase())
                                                                    v.target.value = v.target.value.toUpperCase();
                                                                    general.primerApellidoOtroSecretario = v.target.value;
                                                                    setNombreCS({
                                                                        nombre: nombreCS.nombre,
                                                                        pApellido: v.target.value,
                                                                        sApellido: nombreCS.sApellido
                                                                    })
                                                                }}
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Col>
                                            <Col span={5}>
                                                <Col span={23}>
                                                    <Form.Item name="otroSSA" hasFeedback>
                                                        {getFieldDecorator('otroSSA', {
                                                            initialValue: general.segundoApellidoOtroSecretario !== "" ? general.segundoApellidoOtroSecretario : undefined,
                                                            rules: [
                                                                {
                                                                    pattern: /^[ A-ZÑa-zñáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ']+$/, message: 'Solo acepta (a-z, A-Z, Á-Ú, á-ú) '
                                                                }

                                                            ],
                                                        })(
                                                            <Input
                                                                //className="texto"
                                                                placeholder="Escribe"
                                                                maxLength={40}
                                                                onChange={v => {
                                                                    //console.log("valor de opcion", v.target.name,"hola" ,v.target.value.toUpperCase())
                                                                    v.target.value = v.target.value.toUpperCase();
                                                                    general.segundoApellidoOtroSecretario = v.target.value;
                                                                    setNombreCS({
                                                                        nombre: nombreCS.nombre,
                                                                        sApellido: v.target.value,
                                                                        pApellido: nombreCS.pApellido
                                                                    })
                                                                }}
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Col></>
                                        : ""}
                            </Row>
                            {otroS === 1 || otroE === 1 ?
                                <Row>

                                    <Col span={8}>
                                        <Col span={23}>
                                            <label className="rojo-sesion">* </label><label className="texto-16-sesion">Nombre de la o el escrutador de casilla</label>
                                        </Col>
                                    </Col>
                                    {otroE === 1 ?
                                        <> <Col span={6}>
                                            <Col span={23}>
                                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Nombre(s)</label>
                                            </Col>
                                        </Col>
                                            <Col span={5}>
                                                <Col span={23}>
                                                    <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Primer Apellido</label>
                                                </Col>
                                            </Col>
                                            < Col span={5}>
                                                <Col span={23}>
                                                    <label className="rojo-adjudicacion"> </label><label className="texto-16-adjudicacion">Segundo Apellido</label>
                                                </Col>
                                            </Col></> : ""
                                    }
                                </Row> : ""}
                            {otroS === 1 || otroE === 1 ?
                                <Row>
                                    <Col span={8}>
                                        <Col span={23}>
                                            <Form.Item name="escrutador" hasFeedback>
                                                {getFieldDecorator('escrutador', {
                                                    initialValue: general.escrutador !== "" ? general.escrutador : undefined,
                                                    rules: [
                                                        {
                                                            required: requeridoC,
                                                            message: 'Selecciona el nombre(s) de la o el segundo escrutador de casilla.',
                                                        }
                                                    ],
                                                })(
                                                    <Select
                                                        placeholder="Selecciona"
                                                        disabled={deshabilitarC}
                                                        onSelect={value => {
                                                            value === '0' ?
                                                                setOtroE(1) :
                                                                setOtroE(-1)
                                                            props.general.escrutador = value
                                                        }}
                                                    >
                                                        {Object.entries(escrutador.data).map((value, index) => {
                                                            return <Select.Option key={value[1]}>{value[0]}</Select.Option>;
                                                        })}
                                                        { // RMA Comenta
                                                            /*props.escrutadorN != "" ?
                                                        <Select.Option key={-1}>{props.escrutadorN}</Select.Option> : "" */}

                                                        <Select.Option key={0}>OTRO</Select.Option>

                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Col>
                                    {otroE === 1 ?
                                        <> <Col span={6}>
                                            <Col span={23}>
                                                <Form.Item name="otroEN" hasFeedback>
                                                    {getFieldDecorator('otroEN', {
                                                        initialValue: general.nombreOtroEscrutador !== "" ? general.nombreOtroEscrutador : undefined,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: 'Escribe el nombre(s) de la o el segundo escrutador de casilla.',
                                                            },
                                                            {
                                                                pattern: /^[ A-ZÑa-zñáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ']+$/, 
                                                                message: 'Solo acepta (a-z, A-Z, Á-Ú, á-ú) '
                                                            }
                                                        ],
                                                    })(
                                                        <Input
                                                            //className="texto"
                                                            placeholder="Escribe"
                                                            maxLength={50}
                                                            onChange={v => {
                                                                //console.log("valor de opcion", v.target.name, "hola", v.target.value.toUpperCase())
                                                                v.target.value = v.target.value.toUpperCase()
                                                                general.nombreOtroEscrutador = v.target.value;
                                                                setNombreCE({
                                                                    nombre: v.target.value,
                                                                    pApellido: nombreCE.pApellido,
                                                                    sApellido: nombreCE.sApellido
                                                                })
                                                            }}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        </Col>
                                            <Col span={5}>
                                                <Col span={23}>
                                                    <Form.Item name="otroEPA" hasFeedback>
                                                        {getFieldDecorator('otroEPA', {
                                                            initialValue: general.primerApellidoOtroEscrutador !== "" ? general.primerApellidoOtroEscrutador : undefined,
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: 'Escribe el primer apellido de la o el segundo escrutador de casilla.',
                                                                },
                                                                {
                                                                    pattern: /^[ A-ZÑa-zñáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ']+$/, 
                                                                    message: 'Solo acepta (a-z, A-Z, Á-Ú, á-ú) '
                                                                }
                                                            ],
                                                        })(
                                                            <Input
                                                                //className="texto"
                                                                placeholder="Escribe"
                                                                maxLength={40}
                                                                onChange={v => {
                                                                    //console.log("valor de opcion", v.target.name, "hola", v.target.value.toUpperCase())
                                                                    v.target.value = v.target.value.toUpperCase()
                                                                    general.primerApellidoOtroEscrutador = v.target.value;
                                                                    setNombreCE({
                                                                        nombre: nombreCE.nombre,
                                                                        pApellido: v.target.value,
                                                                        sApellido: nombreCE.sApellido
                                                                    })
                                                                }}
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Col>
                                            <Col span={5}>
                                                <Col span={23}>
                                                    <Form.Item name="otroESA" hasFeedback>
                                                        {getFieldDecorator('otroESA', {
                                                            initialValue: general.segundoApellidoOtroEscrutador !== "" ? general.segundoApellidoOtroEscrutador : undefined,
                                                            rules: [
                                                                {
                                                                    pattern: /^[ A-ZÑa-zñáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ']+$/, message: 'Solo acepta (a-z, A-Z, Á-Ú, á-ú) '
                                                                }

                                                            ],
                                                        })

                                                            (
                                                                <Input
                                                                    //className="texto"
                                                                    placeholder="Escribe"
                                                                    maxLength={40}
                                                                    onChange={v => {
                                                                        //console.log("valor de opcion", v.target.name, "hola", v.target.value.toUpperCase())
                                                                        v.target.value = v.target.value.toUpperCase()
                                                                        general.segundoApellidoOtroEscrutador = v.target.value;
                                                                        setNombreCE({
                                                                            nombre: nombreCE.nombre,
                                                                            sApellido: v.target.value,
                                                                            pApellido: nombreCE.pApellido
                                                                        })
                                                                    }}
                                                                />
                                                            )}
                                                    </Form.Item>
                                                </Col>
                                            </Col>
                                        </>
                                        : ""}

                                </Row>
                                : ""}




                            <Row>
                                <Col span={12}>
                                    <Col span={23}>
                                        <label className="rojo-sesion">* </label><label className="texto-16-sesion">¿Se presentaron a votar personas con discapacidad?</label>
                                    </Col>
                                </Col>

                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Col span={23}>
                                        <Form.Item name="participacion" hasFeedback>
                                            {getFieldDecorator('participacion', {
                                                initialValue: general.participacion !== -1 ? general.participacion : "",
                                                rules: [
                                                    {
                                                        required: requeridoC,
                                                        message: 'Selecciona si hubo o no participación de personas con discapacidad.',
                                                    }
                                                ],
                                            })(
                                                <Radio.Group
                                                    onChange= {
                                                            handleChangeDiscapcidad
                                                        } 
                                                    disabled={deshabilitarC}>
                                                    <Radio value={2}> Sí </Radio>
                                                    <Radio value={1}> No </Radio>
                                                    &nbsp;  &nbsp;
                                                    <br /><span />
                                                </Radio.Group>

                                            )}
                                        </Form.Item>
                                    </Col>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={10}>
                                    <Col span={23}>
                                        <label className="texto-16-adjudicacion">Observaciones</label>
                                    </Col>
                                </Col>
                            </Row>
                            <Row>
                                {console.log("observacione++",general.observaciones)}
                                <Col span={12}>
                                    <Col span={23}>
                                        <Form.Item name="observaciones">
                                            {getFieldDecorator('observaciones', {
                                                initialValue: general.observaciones != "" ? general.observaciones : undefined,
                                            })(
                                                <Input.TextArea
                                                    placeholder="Escribe tus observaciones"
                                                    rows={2}
                                                    autoSize={{ minRows: 2, maxRows: 2 }}
                                                    allowClear={true}
                                                    maxLength={1500}
                                                    disabled={deshabilitarC}
                                                    onChange={v => {
                                                        //console.log("valor de opcion", v.target.name, "hola", v.target.value.toUpperCase())
                                                        //v.target.value=v.target.value.toUpperCase()
                                                        props.general.observaciones = v.target.value
                                                    }}
                                                />
                                            )}
                                            <span style={{color: "#BFBFBF", paddingLeft: "5px"}}>El límite es de 1500 caracteres</span>
                                        </Form.Item>
                                    </Col>
                                </Col>
                            </Row>
                        </> : ""}
                    {visible > 0 ?
                        <></>                        
                        : ""}
                    {console.log("pARTICIPACIÓN", general.participacion)
                    }
                    {/*general.participacion !== 2 && props.accion != 1 ?
                        <Row>
                            <Col>
                                <div className="div_botones">
                                    {props.accion != 1 ? <Button
                                        className="cancelar"
                                        onClick={handleClickCancelar.bind(this)}
                                    > Cancelar </Button> : ""}
                                    <Button
                                        style={{ marginLeft: '10px' }}
                                        type="primary"
                                        className="guardar"
                                        htmlType="submit"
                                        //onClick={props.accion == 1 ?handleClickModificar.bind(this):
                                        //  handleClickGuardar.bind(this)}
                                        disabled={!acciones.enableCaptura }
                                    >GuardarForm</Button>
                                </div>
                            </Col>
                                    </Row> : ""*/}
                </Form>
            </div>
        </div >
    )
}